export function arraysEqual(a, b) {
  if (!a || !b || a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    if (Array.isArray(a[i]) && Array.isArray(b[i])) {
      if (!arraysEqual(a[i], b[i])) return false;
    } else if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}

// names/vehicle come straight from the server payload (see the "all" telegram's
// names.{drivers,team,competitor,displayedName} fields).
export function printName(configJSON, names, vehicle, getFlag) {
  switch (names.nameMode) {
    case 0: { // driver
      const [driver, coDriver] = names.drivers;
      if (!coDriver || coDriver.name === "") {
        return `${getFlag(driver.nat)}${driver.name} ${driver.firstname}`;
      }
      if (configJSON.DoubleWithFirstName) {
        return `${getFlag(driver.nat)}${driver.name} ${driver.firstname}<br>${getFlag(coDriver.nat)}${coDriver.name} ${coDriver.firstname}`;
      }
      return `${getFlag(driver.nat)}${driver.name}<br>${getFlag(coDriver.nat)}${coDriver.name}`;
    }
    case 1: // team
      return names.team;
    case 2: // competitor
      return names.competitor;
    case 3: // vehicle
      return vehicle;
    case 4: // displayedName
      return names.displayedName;
    case 5: { // displayedNameIdx
      const driver = names.drivers[names.driverIndex - 1];
      return `${driver.name} ${driver.firstname} `;
    }
    default:
      return "";
  }
}
